import type {
  LocationQuery,
  RouteParamsGeneric,
  RouteRecordNameGeneric,
  _RouteLocationBase,
} from 'vue-router';

import { ref } from 'vue';
import { defineStore } from 'pinia';
import _cloneDeep from 'lodash/cloneDeep';

export interface BackRoute {
  name: RouteRecordNameGeneric;
  query: LocationQuery;
  params: RouteParamsGeneric;
}

const defPrevUrl = {
  name: '' as RouteRecordNameGeneric,
  url: '' as _RouteLocationBase['fullPath'],
};
const defBackRoutes: BackRoute[] = [];
const defIsShiftBackRoute = false;

export const useRouterStore = defineStore('router', () => {
  const prevUrl = ref(_cloneDeep(defPrevUrl));
  const backRoutes = ref(_cloneDeep(defBackRoutes));
  const isShiftBackRoute = ref(_cloneDeep(defIsShiftBackRoute));

  function $reset(): void {
    prevUrl.value = _cloneDeep(defPrevUrl);
    backRoutes.value = _cloneDeep(defBackRoutes);
    isShiftBackRoute.value = _cloneDeep(defIsShiftBackRoute);
  }

  function setPrevUrl(routeObj: typeof defPrevUrl): void {
    prevUrl.value.name = routeObj.name;
    prevUrl.value.url = routeObj.url;
  }

  function addBackRoute(route: BackRoute): void {
    if (!route.name) return;
    const _backRoutes = backRoutes.value.slice();
    if (_backRoutes[0]?.name === route.name) {
      _backRoutes[0] = route;
    } else {
      _backRoutes.unshift(route);
    }
    backRoutes.value = _backRoutes.slice(0, 10);
  }

  function shiftBackRoute(): void {
    const _backRoutes = backRoutes.value.slice();
    _backRoutes.shift();
    backRoutes.value = _backRoutes.slice(0, 10); // make a limit just in case here
    isShiftBackRoute.value = false;
  }

  function enableIsShiftBackRoute(): void {
    isShiftBackRoute.value = true;
  }

  return {
    prevUrl,
    backRoutes,
    isShiftBackRoute,
    $reset,
    setPrevUrl,
    addBackRoute,
    shiftBackRoute,
    enableIsShiftBackRoute,
  };
});
